import store from '@/store'

export default function(to, from, next) {
    console.log('[Access Guard] Guarding start.')

    if (to.meta.isGuest && store.getters['apiAuth/isAuth']) {
        return next({ name: 'zgody' })
    }

    if (to.meta.isAuth && !store.getters['apiAuth/isAuth']) {
        return next({ name: 'index' })
    }

    if (to.name === 'sampling' && store.getters['apiCampaign/isSampling'] !== true) {
        return next({ name: 'index' })
    }

    console.log('[Access Guard] Guarded.')

    return next()
}